import {Component, ElementRef, Input} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import * as $ from 'jquery';
import MenuTogglerService from "../../services/menuToggler.service";
import IFilter from "../../interfaces/IFilter";
import Filters from "../../services/filters.service";
import * as moment from 'moment';
import QueryParams from "../../services/queryParams.service";

@Component({
    selector: 'main-menu',
    template: require('./menu.component.html'),
    styles: [String(require('./menu.styl'))]
})

export class MenuComponent {
    /**
     * In mapDetails component treatAsRoot is set to false. Thanks to this
     * initial load of mapDetails does not trigger onDateChanged which would redirect back to /measurements
     * Thanks to firstTimeProcess this behaviour works only for the first time because later we want to go back to /measurements
     *
     * @type {boolean}
     */
    @Input() treatAsRoot: boolean = true;
    private firstTimeProcess: boolean = true;

    private byDateFilter: IFilter;
    private timePeriod: string;
    private from = {
        current: null,
        maxDate: null,
        minDate: null,
        activeDate: null
    }
    private to = {
        current: null,
        maxDate: null,
        minDate: null,
        activeDate: null
    }


    constructor(private element: ElementRef,
                private toggler: MenuTogglerService,
                private filters: Filters,
                private activatedRoute: ActivatedRoute,
                private queryParams: QueryParams) {
        this.byDateFilter = this.filters.list["DATE"];
    }

    ngOnInit() {
        this.activatedRoute.queryParams.subscribe((queryParams) => {
            if (!this.treatAsRoot && this.firstTimeProcess) {
                this.processTimePeriod(queryParams["DATE"], {
                    from: queryParams['from'],
                    to: queryParams['to']
                });
                this.firstTimeProcess = false;
            } else if (queryParams["DATE"]) {
                this.onDateChanged(queryParams["DATE"], {
                    from: queryParams['from'],
                    to: queryParams['to']
                });
            } else {
                this.timePeriod = 'all';
                this.handleAllCase();
            }
        });
    }


    ngAfterContentInit() {
        this.toggler.menu = $(this.element.nativeElement)['find']('.menu');
    }


    selectedDate(type: string, date: string) {
        if (this.timePeriod === 'custom') {
            this.queryParams.update({
                [type]: date
            }, this.activatedRoute);
        }
        // in case date was changed on from or to we change mode to custom
        else if (this.timePeriod === 'all') {
            this.queryParams.update({
                [this.byDateFilter.name]: 'custom',
                [type]: date
            }, this.activatedRoute);
        }
    }

    private handleAllCase() {
        this.from.minDate = this.to.minDate = this.to.current = this.from.current = null;
        this.from.activeDate = this.to.activeDate = new Date();
        this.from.maxDate = this.to.maxDate = new Date();
    }

    private processTimePeriod(timePeriod: string, customRanges = {from: null, to: null}) {
        this.timePeriod = timePeriod;
        if (timePeriod === 'today') {
            const today = moment().toDate();
            this.from.maxDate = this.from.minDate = this.from.activeDate = moment().startOf('day').toDate();
            this.to.maxDate = this.to.minDate = this.to.activeDate = moment().endOf('day').toDate();
        } else if (timePeriod === 'yesterday') {
            const yesterday = moment().add(-1, 'days').toDate();
            this.from.maxDate = this.from.minDate = this.from.activeDate = moment().add(-1, 'days').startOf('day').toDate();
            this.to.maxDate = this.to.minDate = this.to.activeDate = moment().add(-1, 'days').endOf('day').toDate();
        } else if (timePeriod === 'last 7 days') {
            this.from.maxDate = this.from.minDate = this.from.activeDate = moment().add(-7, 'days').startOf('day').toDate();
            this.to.maxDate = this.to.minDate = this.to.activeDate = moment().endOf('day').toDate();
        } else if (timePeriod === 'last 30 days') {
            this.from.maxDate = this.from.minDate = this.from.activeDate = moment().add(-30, 'days').startOf('day').toDate();
            this.to.maxDate = this.to.minDate = this.to.activeDate = moment().endOf('day').toDate();
        } else if (timePeriod === 'this month') {
            this.from.maxDate = this.from.minDate = this.from.activeDate = moment().startOf('month').startOf('day').toDate();
            this.to.maxDate = this.to.minDate = this.to.activeDate = moment().endOf('day').toDate();
        } else if (timePeriod === 'custom') {
            this.from.minDate = this.to.minDate = null;
            if (customRanges.from) {
                this.from.activeDate = moment(new Date(customRanges.from)).startOf('day').toDate();
            } else {
                this.from.activeDate = moment().startOf('day').toDate();
            }
            if (customRanges.to) {
                this.to.activeDate = moment(new Date(customRanges.to)).endOf('day').toDate();
            } else {
                this.to.activeDate = moment().endOf('day').toDate();
            }
            this.from.maxDate = this.to.maxDate = moment().endOf('day').toDate();
        } else if (timePeriod === 'all') {
            this.handleAllCase();
        }
    }

    onDateChanged(timePeriod: string, customRanges = {from: null, to: null}) {
        this.processTimePeriod(timePeriod, customRanges)
        this.queryParams.update({
            [this.byDateFilter.name]: timePeriod,
            'from': this.from.activeDate,
            'to': this.to.activeDate
        }, this.activatedRoute);
    }

}



// WEBPACK FOOTER //
// ./src/app/components/menu/menu.component.ts